import { useEffect, useRef } from "react";
import { observer, inject } from "mobx-react";
import { toJS } from "mobx";
import dayjs from "dayjs";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Tabs } from "antd-mobile";
import Main from "../../components/main";
import Content from "../../components/content";
import SideNav from "./components/sideNav";
import History from "./components/history";
import api from "../../services/api";
import toast from "../../components/toast";
import { httpGet, http } from "../../services/fetcher";
import BetArea from "./components/betArea";
import ShopCart from "./components/shopCart";
import SecondTabsModal from "./components/secondTabsModal";
import LotteryResult from "./components/lotteryResult";
import styles from "./index.module.scss";
import { classNames, arrayCombine } from "../../tool";
import { useSetState } from "ahooks";
import PlayContent from "./components/playContent";
import Modal from "../../components/modal";

const defaultArr = ["", "", "", "", "", "", ""];
function Play({ store }) {
  const { balanceInfo, playInfo, setPlayInfo } = store || {};
  const playInfoJs = toJS(playInfo) || {};
  // 当前期号信息
  const currentIssue = toJS(store.currentIssue) || {};

  const { dicInfo } = store;
  const rules =
    (JSON.parse(playInfoJs.playInfo || "{}").LHC || {}).playInfo || [];
  const [state, setState] = useSetState({
    firstPlay: {}, // 一级玩法
    secondPlay: {}, // 二级玩法
    secondIndex: 0,
    showBetModal: false, // 展开投注弹窗
    showBetFloat: false, // 显示可以投注的浮窗
    selectPlays: [], // 选中的玩法
    isSeal: false, // 是否封盘
    historyIssue: [], // 前5期开奖信息
    preIssue: {}, //上期期号信息
    preResult: [], // 上期开奖结果
    currentHandicap: localStorage.getItem("handicap") || "", // 当前盘口
    handicapColumns: [], // 盘口数组
    ruleVisible: false,
    pwdVisible: false,
    noticeVisible: false,
    noticeList: [],
    noticeIndex: 0,
    sideVisible: false,
    historyVisible: false,
    shopCartVisible: false,
    shopCartType: 1, // 1 购物车 2 下注明细
    betMoney: "",
    secondTabsModalVisible: false,
    liveUrl: "",
    liveVisible: "",
  });
  const {
    firstPlay,
    secondPlay,
    secondIndex,
    showBetModal,
    showBetFloat,
    selectPlays,
    preIssue,
    historyIssue,
    isSeal,
    preResult,
    currentHandicap,
    noticeVisible,
    noticeList,
    noticeIndex,
    sideVisible,
    historyVisible,
    shopCartVisible,
    shopCartType,
    betMoney,
    secondTabsModalVisible,
    liveUrl,
    liveVisible,
  } = state;
  // 赔率
  const playOddInfo = playInfoJs[`playOddInfo${currentHandicap}`] || [];
  const { stime, etime, ctime } = currentIssue || {};
  const { rowId } = preIssue || {};
  const lotteryResult = (preIssue || {}).lotteryResult
    ? (preIssue || {}).lotteryResult
    : defaultArr;
  const showSelectPlaysRes = useRef([]);
  // useEffect(() => {
  //   const getNotice = async () => {
  //     const res = await http(api.noticeList, {
  //       page: {
  //         current: 1,
  //         size: 999,
  //       },
  //     });
  //     if (res.code === "C2") {
  //       const list = res.result.records;
  //       setState({
  //         noticeList: list,
  //       });
  //     }
  //   };
  //   getNotice();
  // }, []);
  useEffect(() => {
    if (balanceInfo) {
      const betHall = balanceInfo.betHall;
      const betHallArr =
        (betHall || "").split("_").filter((i) => i !== "") || [];
      const handicapArr = betHallArr.map((i) => {
        return {
          label: i,
          value: i,
        };
      });
      // 当前盘口是否在开通盘口中
      const isIn = betHallArr.findIndex((i) => i === currentHandicap) !== -1;
      setState({
        handicapColumns: handicapArr,
        currentHandicap:
          currentHandicap && isIn ? currentHandicap : betHallArr[0],
      });
    }
  }, [balanceInfo]);
  // useEffect(() => {
  //   if (noticeList.length) {
  //     setState({
  //       noticeVisible: true,
  //     });
  //   }
  // }, [noticeList.length]);
  useEffect(() => {
    if (rowId && lotteryResult.length) {
      const resultArr = JSON.parse(JSON.stringify(lotteryResult));
      resultArr.splice(resultArr.length - 1, 0, "+");
      setState({
        preResult: resultArr || [],
      });
    }
  }, [rowId]);

  useEffect(() => {
    // 当前时间小于结束时间 大于封盘时间
    if (ctime >= stime && ctime <= etime) {
      setState({
        isSeal: true,
      });
    } else {
      setState({
        isSeal: false,
      });
    }
  }, [etime]);
  useEffect(() => {
    if (isSeal) {
      toast("已封盘");
    }
  }, [isSeal]);
  // 获取上期信息
  const getPreIssuse = async () => {
    const res = await http(api.historyIssue, {
      page: {
        current: 1,
        size: 20,
      },
    });
    if (res.code === "C2") {
      const records = (res.result || {}).records || [];
      const issue = records[0] || {};
      setState({
        preIssue: issue,
        historyIssue: records,
      });
    }
  };

  useEffect(() => {
    // 请求用户余额
    store.getBalanceInfo();
    // 请求玩法规则
    const getPlayInfo = async () => {
      const res = await httpGet(api.playInfo);

      if (res.code === "C2") {
        setPlayInfo(res.result);
      }
    };
    if (rules.length === 0) {
      getPlayInfo();
    }
    // 获取当期信息
    store.getcurrentIssue();
    // 获取上期信息
    getPreIssuse();
  }, []);

  // 初始化规则
  useEffect(() => {
    if (rules.length) {
      const first = rules[0];
      const second = rules[0].children ? rules[0].children[0] : {};
      setState({
        firstPlay: first,
        secondPlay: second,
      });
    }
  }, [rules.length]);

  /** 选择玩法 */
  const handleSelectPlays = (play, second) => {
    let newSelectPlays = JSON.parse(JSON.stringify(selectPlays));
    // 是否已经选择此玩法
    const idx = newSelectPlays.findIndex(
      (i) =>
        i.code === play.code &&
        i.secondCode === (second ? second.code : secondPlay.code)
    );
    if (idx !== -1) {
      newSelectPlays.splice(idx, 1);
    } else {
      newSelectPlays.unshift({
        ...play,
        firstCode: firstPlay.code,
        firstName: firstPlay.name,
        secondCode: second ? second.code : secondPlay.code,
        secondName: second ? second.name : secondPlay.name,
      });
    }
    let canBet = newSelectPlays.length > 0;
    if (newSelectPlays.length > 15) {
      const delIdx = newSelectPlays.findIndex(
        (i) => i.code === play.code && i.secondCode === secondPlay.code
      );
      toast("不能超过15个号码");
      newSelectPlays.splice(delIdx, 1);
      return;
    }
    if (
      firstPlay.code === "LM" ||
      firstPlay.code === "ZXBZ" ||
      firstPlay.code === "LXLW" ||
      firstPlay.code === "HX"
    ) {
      let needCout = 0;
      switch (secondPlay.code) {
        case "EQZ":
        case "EZT":
        case "TC":
        case "EHX":
        case "ELX":
        case "ELW":
          needCout = 2;
          break;
        case "SANQZ":
        case "SANZE":
        case "SANHX":
        case "SANLX":
        case "SANLW":
          needCout = 3;
          break;
        case "SIQZ":
        case "SIHX":
        case "SILX":
        case "SILW":
          needCout = 4;
          break;
        case "WHX":
        case "WLX":
        case "WLW":
        case "ZX05BZ":
          needCout = 5;
          break;
        case "ZX06BZ":
        case "LHX":
          needCout = 6;
          break;
        case "ZX07BZ":
          needCout = 7;
          break;
        case "ZX08BZ":
          needCout = 8;
          break;
        case "ZX09BZ":
          needCout = 9;
          break;
        case "ZX10BZ":
          needCout = 10;
          break;
        case "ZX11BZ":
          needCout = 11;
          break;
        case "ZX12BZ":
          needCout = 12;
          break;
        default:
          break;
      }
      canBet = newSelectPlays.length >= needCout;
      if (canBet) {
        showSelectPlaysRes.current = arrayCombine(newSelectPlays, needCout);
      } else {
        showSelectPlaysRes.current = [];
      }
    }
    setState({
      selectPlays: newSelectPlays,
      showBetFloat: canBet,
      showBetModal: canBet ? showBetModal : false,
      shopCartVisible: canBet ? shopCartVisible : false,
      betMoney: canBet ? betMoney : "",
    });
  };

  /**随机添加一个球 */
  const handleRandom = () => {
    // 判断是否超出最大数目15个
    if (selectPlays.length === 15) {
      toast("不能超过15个号码");
      return;
    }
    let plays = firstPlay.children ? secondPlay.plays : firstPlay.plays;
    let leftPlaysArr = plays.filter(
      (i) => selectPlays.findIndex((it) => it.code === i.code) == -1
    );
    // 正码1-6可以选择所有字玩法的投注内容
    if (firstPlay.code === "ZMYL") {
      plays = [];
      firstPlay.children.map((i) => {
        plays = plays.concat(
          i.plays.map((it) => {
            return {
              ...it,
              secondCode: i.code,
              secondName: i.name,
            };
          })
        );
      });
      leftPlaysArr = plays.filter(
        (i) =>
          selectPlays.findIndex(
            (it) => it.code === i.code && it.secondCode === i.secondCode
          ) == -1
      );
    }
    if (leftPlaysArr.length) {
      const randomIndex = Math.floor(Math.random() * leftPlaysArr.length);
      const newPlays = JSON.parse(JSON.stringify(selectPlays));
      newPlays.push({
        ...leftPlaysArr[randomIndex],
        firstCode: firstPlay.code,
        firstName: firstPlay.name,
        secondCode: leftPlaysArr[randomIndex].secondCode
          ? leftPlaysArr[randomIndex].secondCode
          : secondPlay.code,
        secondName: leftPlaysArr[randomIndex].secondName
          ? leftPlaysArr[randomIndex].secondName
          : secondPlay.name,
      });
      if (
        firstPlay.code === "LM" ||
        firstPlay.code === "ZXBZ" ||
        firstPlay.code === "LXLW" ||
        firstPlay.code === "HX"
      ) {
        let needCout = 0;
        switch (secondPlay.code) {
          case "EQZ":
          case "EZT":
          case "TC":
          case "EHX":
          case "ELX":
          case "ELW":
            needCout = 2;
            break;
          case "SANQZ":
          case "SANZE":
          case "SANHX":
          case "SANLX":
          case "SANLW":
            needCout = 3;
            break;
          case "SIQZ":
          case "SIHX":
          case "SILX":
          case "SILW":
            needCout = 4;
            break;
          case "WHX":
          case "WLX":
          case "WLW":
          case "ZX05BZ":
            needCout = 5;
            break;
          case "ZX06BZ":
          case "LHX":
            needCout = 6;
            break;
          case "ZX07BZ":
            needCout = 7;
            break;
          case "ZX08BZ":
            needCout = 8;
            break;
          case "ZX09BZ":
            needCout = 9;
            break;
          case "ZX10BZ":
            needCout = 10;
            break;
          case "ZX11BZ":
            needCout = 11;
            break;
          case "ZX12BZ":
            needCout = 12;
            break;
          default:
            break;
        }
        showSelectPlaysRes.current = arrayCombine(newPlays, needCout);
      }
      setState({
        selectPlays: newPlays,
      });
    }
  };

  // 确定投注
  const handleBet = async (money) => {
    if (!Number(money)) {
      toast("请输入正确的下注金额");
      return;
    }
    let paramsArr = [];
    if (firstPlay.code === "ZMYL") {
      const arr = [];
      selectPlays.forEach((item) => {
        const idx = arr.findIndex((i) => i.secondCode === item.secondCode);
        if (idx === -1) {
          arr.push({
            ...item,
            oddsArr: [item.code],
          });
        } else {
          arr[idx].oddsArr.push(item.code);
        }
      });
      paramsArr = arr.map((i) => {
        return {
          issueId: currentIssue.rowId,
          playCode1: "LHC",
          playCode2: i.firstCode,
          playCode3: i.secondCode,
          betContent: i.oddsArr,
          unitAmount: money,
          betHall: currentHandicap,
          playCode2Name: i.firstName,
          playCode3Name: i.secondName,
          betOdds:
            playOddInfo[
              `LHC_${i.firstCode}_${i.secondCode}${selectPlays[0].code}`
            ],
        };
      });
    } else {
      paramsArr = [
        {
          issueId: currentIssue.rowId,
          playCode1: "LHC",
          playCode2: firstPlay.code,
          playCode3: secondPlay.code || firstPlay.code,
          betContent: selectPlays.map((i) => i.code),
          unitAmount: money,
          betHall: currentHandicap,
          playCode2Name: firstPlay.name,
          playCode3Name: secondPlay.name || firstPlay.name,
          betOdds:
            playOddInfo[
              `LHC_${firstPlay.code}_${secondPlay.code || firstPlay.code}${
                selectPlays[0].code
              }`
            ],
        },
      ];
    }
    const res = await http(api.bet, paramsArr);
    if (res.code === "C2") {
      setState({
        betMoney: "",
        shopCartVisible: false,
        selectPlays: [],
        showBetModal: false,
        showBetFloat: false,
      });
      toast("投注成功");
      // 投注成功后刷新余额
      store.getBalanceInfo();
    } else {
      toast(res.message || "投注失败");
    }
  };

  /**一级玩法 */
  const renderFirstTabs = () => {
    const firstIndex = rules.findIndex(
      (i) => i.code === firstPlay.code && i.name === firstPlay.name
    );
    return rules.map((item, index) => {
      return (
        <div
          className={classNames(
            styles.navItem,
            firstIndex - 1 === index ? styles.noBorder : "",
            item.code === firstPlay.code && item.name === firstPlay.name
              ? styles.active
              : ""
          )}
          key={index}
          onClick={() => {
            const second = item.children ? item.children[0] : {};
            setState({
              firstPlay: item,
              secondPlay: second,
              secondIndex: 0,
              selectPlays: [],
              showBetFloat: false,
            });
          }}
        >
          {item.name}
        </div>
      );
    });
  };
  /**二级玩法 */
  const secondTabs = firstPlay.children || [];
  const renderSecondTabs = () => {
    const keyStr = String(secondIndex);
    return (
      <div
        className={classNames(
          styles.secondTabs,
          secondTabs.length > 3 ? styles.secondTabsMore : ""
        )}
      >
        <Tabs
          key={firstPlay.code}
          activeKey={keyStr}
          stretch={false}
          onChange={(index) => {
            setState({
              secondIndex: String(index),
              secondPlay: secondTabs[index],
              showBetFloat: false,
              selectPlays: [],
            });
          }}
        >
          {secondTabs.map((item, index) => {
            return <Tabs.Tab key={String(index)} title={item.name}></Tabs.Tab>;
          })}
        </Tabs>
        {secondTabs.length > 3 ? (
          <div
            className={styles.tabsMore}
            onClick={() => {
              setState({
                secondTabsModalVisible: true,
              });
            }}
          >
            <img src={require("../../assets/imgs/new/tabMore.png")} />
          </div>
        ) : (
          ""
        )}
      </div>
    );
  };
  return (
    <Main className={styles.main}>
      <Content className={styles.content}>
        <div className={styles.topContent}>
          <div className={styles.header}>
            <div className={styles.left}>澳门六合彩</div>
            <div className={styles.right}>
              <div className={styles.balance}>
                <span>余额：</span>
                <span>{balanceInfo.balance ? balanceInfo.balance : "0"}</span>
              </div>
              <img
                onClick={() =>
                  setState({
                    sideVisible: true,
                  })
                }
                className={styles.iconMore}
                src={require("../../assets/imgs/new/icon_more.png")}
              />
            </div>
          </div>
          <LotteryResult
            dicInfo={dicInfo}
            isSeal={isSeal}
            lotteryResult={lotteryResult}
            balanceInfo={balanceInfo}
            currentIssue={currentIssue}
            preResult={preResult}
            preIssue={preIssue}
            setState={setState}
            onEnd={() => {
              // 封盘中倒计时结束
              if (isSeal) {
                getPreIssuse();
                // 获取当期信息
                store.getcurrentIssue();
              }
              setState({
                isSeal: !isSeal,
              });
            }}
          />
          {/* {renderLotteryResult()} */}
        </div>
        <div
          className={classNames(
            styles.playContent,
            showBetFloat ? styles.playContentShort : ""
          )}
        >
          <div className={styles.playInner}>
            <div className={styles.leftNav}>{renderFirstTabs()}</div>
            <div className={styles.rightPlay}>
              {firstPlay.children &&
              firstPlay.children.length > 1 &&
              firstPlay.code !== "ZMYL"
                ? renderSecondTabs()
                : ""}
              <div
                className={classNames(
                  styles.playContainer,
                  firstPlay.children &&
                    firstPlay.children.length > 1 &&
                    firstPlay.code !== "ZMYL"
                    ? styles.playContainer2
                    : ""
                )}
              >
                <PlayContent
                  firstPlay={firstPlay}
                  secondPlay={secondPlay}
                  selectPlays={selectPlays}
                  onBet={handleSelectPlays}
                  playOddInfo={playOddInfo}
                />
              </div>
            </div>
          </div>
        </div>
        {showBetFloat ? (
          <BetArea
            balanceInfo={store.balanceInfo}
            selectPlays={selectPlays}
            currentIssue={currentIssue}
            showSelectPlays={showSelectPlaysRes.current}
            handleSelectPlays={handleSelectPlays}
            onBet={(type) => {
              setState({
                shopCartVisible: true,
                shopCartType: type,
              });
            }}
            // 投注成功后请求余额
            getBalanceInfo={() => {
              store.getBalanceInfo();
            }}
            handleRandom={handleRandom}
            onDelete={() => {
              setState({
                selectPlays: [],
                showBetModal: false,
                showBetFloat: false,
                betMoney: "",
              });
            }}
            onChangeBetMoney={(money) => {
              setState({
                betMoney: money,
              });
            }}
            betMoney={betMoney}
            secondPlay={secondPlay}
            firstPlay={firstPlay}
            playOddInfo={playOddInfo}
            currentHandicap={currentHandicap}
          />
        ) : (
          ""
        )}
      </Content>

      <Modal visible={noticeVisible}>
        <div className={styles.noticeModal}>
          <div
            className={styles.close}
            onClick={() => {
              localStorage.removeItem("login");
              setState({
                noticeVisible: false,
              });
            }}
          />
          <div className={styles.title}>系统公告</div>
          <div className={styles.noticeContent}>
            <Swiper
              onTransitionEnd={(swiper) => {
                setState({
                  noticeIndex: swiper.activeIndex,
                });
              }}
            >
              {noticeList.map((item, index) => (
                <SwiperSlide className={styles.swiperSlide} key={index}>
                  <div className={styles.noticeTitle}>{item.noticeTitle}</div>
                  <div className={styles.text}>{item.noticeText}</div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          <div className={styles.noticeFooter}>
            <div className={styles.tip}>
              <div className={styles.name}>六合彩官方</div>
              <div className={styles.time}>
                {dayjs(
                  noticeList[noticeIndex]
                    ? noticeList[noticeIndex].createTime
                    : ""
                ).format("YYYY-MM-DD")}
              </div>
            </div>
            <div className={styles.pagination}>
              {noticeList.map((item, index) => (
                <div
                  key={index}
                  className={classNames(
                    styles.bullet,
                    index === noticeIndex ? styles.active : ""
                  )}
                />
              ))}
            </div>
          </div>
        </div>
      </Modal>
      <SideNav
        visible={sideVisible}
        handleHide={() => setState({ sideVisible: false })}
      />
      <SecondTabsModal
        visible={secondTabsModalVisible}
        handleHide={() => setState({ secondTabsModalVisible: false })}
        list={secondTabs}
        activeIndex={String(secondIndex)}
        onClick={(index) => {
          setState({
            secondIndex: String(index),
            secondPlay: secondTabs[index],
            showBetFloat: false,
            selectPlays: [],
          });
        }}
      />
      <History
        visible={historyVisible}
        handleHide={() => setState({ historyVisible: false })}
        historyIssue={historyIssue}
        dicInfo={dicInfo}
        onShowVideo={(url) => {
          setState({
            liveUrl: url,
            liveVisible: true,
          });
        }}
      />
      <ShopCart
        visible={shopCartVisible}
        handleHide={() => setState({ shopCartVisible: false })}
        type={shopCartType}
        balanceInfo={store.balanceInfo}
        selectPlays={selectPlays}
        currentIssue={currentIssue}
        showSelectPlays={showSelectPlaysRes.current}
        firstPlay={firstPlay}
        playOddInfo={playOddInfo}
        money={betMoney}
        handleSelectPlays={handleSelectPlays}
        secondPlay={secondPlay}
        getBalanceInfo={() => {
          store.getBalanceInfo();
        }}
        handleBet={handleBet}
        onDelete={() => {
          setState({
            shopCartVisible: false,
            selectPlays: [],
            showBetModal: false,
            showBetFloat: false,
            betMoney: "",
          });
        }}
      />
      <Modal
        visible={liveVisible}
        className={styles.videoModal}
        close={() =>
          setState({
            liveVisible: false,
            liveUrl: "",
          })
        }
      >
        <div className={styles.video}>
          <video src={liveUrl} controls autoPlay></video>
        </div>
      </Modal>
    </Main>
  );
}

export default inject("store")(observer(Play));
